
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_16554_19713)","fill":"#000"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 4c0-1.406.75-2.719 2-3.438 1.219-.718 2.75-.718 4 0 1.219.72 2 2.032 2 3.438 0 1.438-.781 2.75-2 3.469-1.25.718-2.781.718-4 0A3.977 3.977 0 013 4zm7 0c0-1.063-.594-2.031-1.5-2.594-.938-.531-2.094-.531-3 0C4.562 1.97 4 2.938 4 4a3.03 3.03 0 001.5 2.625c.906.531 2.063.531 3 0C9.406 6.062 10 5.094 10 4z"}}),_c('path',{attrs:{"d":"M1 15h9.508a.5.5 0 110 1H.906A.907.907 0 010 15.094C0 12 2.469 9.5 5.563 9.5h2.843c1.272 0 2.444.423 3.383 1.136a.568.568 0 01.219.455v.022a.459.459 0 01-.46.459.614.614 0 01-.37-.13 4.545 4.545 0 00-2.772-.942H5.562A4.575 4.575 0 001 15z"}}),_c('path',{attrs:{"d":"M16 13.5c0 .281-.25.5-.5.5H14v1.5c0 .281-.25.5-.5.5a.494.494 0 01-.5-.5V14h-1.5a.494.494 0 01-.5-.5c0-.25.219-.5.5-.5H13v-1.5c0-.25.219-.5.5-.5.25 0 .5.25.5.5V13h1.5c.25 0 .5.25.5.5z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_16554_19713"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    